import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, combineLatest, distinctUntilChanged, filter, map, mergeMap, startWith } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { selectBetBuilderNotification } from '../../../notifications/selectors';
import { selectBetslipErrors, selectHasOfferChanged, selectHasOfferChangedFromBetPlacement } from '../../selectors';
import { ErrorViewModelService } from '../../services/error-viewmodel.service';
import { SummaryErrorsViewModel } from '../common/errors-container.component';

@Component({
    selector: 'bs-linear-summary-errors',
    template: `
        @if (viewModel$ | async; as vm) {
            <bs-errors-container [viewModel]="vm" (errorDisplayChange)="errorDisplayChange.emit($event)" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearSummaryErrorsComponent implements OnInit {
    @Output() errorDisplayChange = new EventEmitter<boolean>();

    viewModel$: Observable<SummaryErrorsViewModel>;

    constructor(
        private store: Store<IBetslipRootState>,
        private viewModelService: ErrorViewModelService,
    ) {}

    ngOnInit(): void {
        const errors$ = this.store.select(selectBetslipErrors).pipe(mergeMap((state) => this.viewModelService.getErrorViewModels$(state)));

        const betBuilderNotification$ = this.store.select(selectBetBuilderNotification).pipe(
            filter((notification) => notification !== null),
            distinctUntilChanged(),
            startWith(null),
        );

        const isOfferChanged$ = this.store.select(selectHasOfferChanged);
        const isBetPlacementOfferChanged$ = this.store.select(selectHasOfferChangedFromBetPlacement);

        this.viewModel$ = combineLatest([errors$, isOfferChanged$, isBetPlacementOfferChanged$, betBuilderNotification$]).pipe(
            map(([errors, isOfferChanged, isBetPlacementOfferChanged, betBuilderNotification]) => ({
                errors,
                isOfferChanged,
                isBetPlacementOfferChanged,
                betBuilderNotification,
            })),
        );
    }
}
